import styled from '@emotion/styled';
import { Div } from '../../layouts';

export const DatePickerContentEl = styled(Div)`
    ${({ large }) => large && `
        min-width: 900px;
    `}
    .odf-rtl && {
      left: 0;
      right: auto;
    }
    && {
        right: 0;
    }
`;
